<ng-container *ngIf="operationItems">
  <div
    data-at-operation-items
    class="border rounded-lg bg-white mt-4"
    [class.remove-bottom-border]="versionList.currentBundleVersion"
  >
    <ng-container *ngFor="let operation of operationItems">
      <app-firmware-update-operation-status
        [operation]="operation"
      ></app-firmware-update-operation-status>
    </ng-container>
  </div>
</ng-container>

<ng-container *ngIf="xotaUpdateOperation.updateMethod === Xota2UpdateProgress.XOTA_ONE">
  <div
    data-at-bundle-update-check
    [class.remove-top-border]="xotaUpdateOperation"
    class="flex flex-col gap-3 border rounded-lg bg-white"
    *ngIf="versionList.currentBundleVersion && versionList.isLoading"
  >
    <div *ngFor="let item of versionList.currentBundleVersion" class="flex flex-col">
      <div class="flex gap-2 justify-between p-4">
        <p>{{ item.ecuName | translate }}</p>
        <ng-container *ngIf="item.isMissing; else checkVersions">
          <div class="flex items-center gap-2">
            <mat-icon class="warning-icon">error</mat-icon>
            <p class="firmware_text">
              {{ 'FIRMWARE_UPDATE_MODAL.FIRMWARE_VERSION_LIST.MISSING' | translate }}
            </p>
          </div>
        </ng-container>

        <ng-template #checkVersions>
          <ng-container *ngIf="checkIfHaveVersion(item.otaVersions); else upToDate">
            <ng-container *ngFor="let otaVersion of item.otaVersions">
              <p class="firmware_text" *ngIf="otaVersion.otaType === BundleUpdateOtaType.FOTA">
                {{ otaVersion.version }}
              </p>
            </ng-container>
          </ng-container>
        </ng-template>

        <ng-template #upToDate>
          <p class="firmware_text">
            {{
              '+INSTALLATIONS.INSTALLATION.FIRMWARE_UPDATE_MODAL.FIRMWARE_VERSION_LIST.UP_TO_DATE'
                | translate
            }}
          </p>
        </ng-template>
      </div>
      <hr />
    </div>
  </div>
</ng-container>
